import React, { forwardRef } from "react";
import { default as MUIBox } from "@mui/material/Box";

export const Box = forwardRef(({ children, ...props }, ref) => (
  <MUIBox ref={ref} {...props}>
    {children}
  </MUIBox>
));

export default Box;
